<div *ngIf="loading"
     class="loading-overlay">
  <i class="fa fa-2x fa-spinner fa-spin text-secondary"></i>
  <h3 class="mt-3 ml-1 text-secondary">Cargando...</h3>
</div>

<!-- Cabecera -->
<div class="row">
  <div class="col-12 animated fadeIn fast">

    <div class="card border border-info rounded">
      <div class="card-body ">



        <!-- cabecera -->
        <div class="row mb-2">

          <div class="col-2">
            <div class="subTitulo text-info">
              {{subTitulo}}
            </div>
          </div>


          <!-- Busca todo -->
          <div class="col-3">
            <div class="input-group border border-dark rounded">
              <input class="form-control"
                     type="text"
                     id="buscaTodo"
                     autofocus
                     placeholder="Buscar cualquier dato..."
                     [(ngModel)]="strBuscarTodo"
                     (keyup)="buscarTodo($event)" />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary"
                        type="button"
                        title="Limpiar búsqueda"
                        (click)="limpiaBusca()">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>


          <!-- cliSeleccionado -->
          <div class="col-3">
            <div class="input-group border border-dark rounded">
              <div class="input-group-addon"><i class="fa-solid fa-user"></i></div>
              <select class="form-control"
                      [disabled]="loading"
                      [(ngModel)]="cliSeleccionado"
                      (ngModelChange)="onClienteSelect($event)">
                <option value=''>Todos los clientes</option>
                <option *ngFor="let cli of clientesList"
                        [value]=cli.id>
                  {{cli.nombre}}
                </option>
              </select>
            </div>
          </div>


          <div class="col-1 text-right">
            <span *ngIf="swEnStock==='1' && rows.length > 0">
              <button [disabled]="loading"
                      class="ml-2 btn waves-effect waves-light btn-rounded btn-secondary"
                      (click)="confirmarTodo()">
                <i class="fa fa-spinner fa-spin"
                   *ngIf="loading"></i> Confirmar todo
              </button>
            </span>
          </div>

          <div class="col-3">

            <form>

              <div class="row float-right">

                <div class="col-sm-5">
                  <div class="form-group rounded">
                    <select class="form-control"
                            name="rowsLimitStr"
                            [(ngModel)]="rowsLimitStr"
                            (change)="rowsLimitChange()">
                      <option [value]="10">10</option>
                      <option [value]="50">50</option>
                      <option [value]="100">100</option>
                      <option [value]="999999">Todo</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-7">
                  <div class="form-group float-right">
                    <div class="btn-group">
                      <button type="button"
                              (click)="getListaEntradas()"
                              class="btn btn-outline-info btn-circle"
                              title="Recargar datos">
                        <i class="fa-solid fa-sync"></i>
                      </button>
                      <button type="button"
                              (click)="table.rowDetail.expandAllRows()"
                              class="btn btn-outline-info btn-circle  "
                              title="Expandir todo">
                        <i class="fa-solid fa-angles-down"></i>
                      </button>
                      <button type="button"
                              (click)="table.rowDetail.collapseAllRows()"
                              class="btn btn-outline-info btn-circle  "
                              title="Colapsar todo">
                        <i class="fa-solid fa-angles-up"></i>
                      </button>
                      <button type="button"
                              [ngClass]="{'disabled': loading}"
                              (click)="exportToExcel()"
                              class="btn btn-outline-info btn-circle"
                              title="Descargar Excel">
                        <i class="fa-solid fa-download"></i>
                      </button>

                    </div>
                  </div>
                </div>

              </div>

            </form>
          </div>

        </div>


        <!-- Datatable -->
        <ngx-datatable #myTable
                       class="bootstrap"
                       [style.width]="'100%'"
                       [rows]="rows"
                       [messages]="messages"
                       [columnMode]="ColumnMode.force"
                       [limit]="rowsLimit"
                       [headerHeight]="50"
                       [rowHeight]="50"
                       [scrollbarV]="false"
                       [footerHeight]="50"
                       [summaryRow]="true"
                       [summaryHeight]="55"
                       [summaryPosition]="summaryPosition"
                       (page)="onPage($event)"
                       (activate)="onActivate($event)">

          <!-- Row Detail Template -->
          <ngx-datatable-row-detail [rowHeight]="100"
                                    #myDetailRow
                                    (toggle)="onDetailToggle($event)">
            <ng-template let-row="row"
                         let-expanded="expanded"
                         ngx-datatable-row-detail-template>
              <div class="bootstrap-table table-bordered border-info"
                   style="margin-left:35px;margin-right:35px; margin-bottom: 5px;">
                <div class="table-responsive">
                  <table class="table table-sm table-hover"
                         style="table-layout: fixed; width: 100%;">
                    <thead>
                      <tr>
                        <th style="width: 80px">Palé</th>
                        <th style="width: 80px"></th>
                        <th style="width: 140px"><i class="fa fa-barcode"></i> Ean</th>
                        <th style="width: 170px">Sku</th>
                        <th>Artículo</th>
                        <th style="width: 100px">Lote</th>
                        <th style="width: 110px">Fec. caducidad</th>
                        <th style="width: 90px; text-align: right;">Cantidad</th>
                        <th style="width: 150px">Ubicación</th>
                      </tr>
                    </thead>
                    <tbody *ngIf="row?.detall">
                      <ng-container *ngFor="let lin of row.detall; let i = index">
                        <tr *ngIf="i > 0 && lin.pale != row.detall[i-1].pale"
                            style="height: 4px; background-color: #e9ecef;">
                          <td colspan="9"
                              style="padding: 0; height: 4px; background-color: #e9ecef; border: none;"></td>
                        </tr>
                        <tr>
                          <td>{{ lin.pale }}</td>
                          <td>
                            <img [src]="fotoDir +'/articulos' + imgResized + lin.artFoto"
                                 loading="lazy"
                                 alt="Foto"
                                 class="rounded pointer border"
                                 height="25px"
                                 (click)="abrirPopupImagen(fotoDir + '/articulos' + '/' + lin.artFoto)">
                          </td>
                          <td>{{ lin.artEan }}</td>
                          <td>{{ lin.artSku }}
                            <span *ngIf="lin.swDefectuoso == Constantes.DEFECTUOSO"
                                  class="text-warning ml-12">
                              <i title="Defectuoso"
                                 class="text-warning ml-1 fa-solid fa-triangle-exclamation"></i>
                            </span>
                          </td>
                          <td title="{{ lin.artDescripcion }}">{{funcLib.limitarYAgregarPuntos( lin.artDescripcion, 80) }}</td>
                          <td>{{ lin.lote }}</td>
                          <td><span [innerHTML]="lin.fecha_caducidad | iconFechaCaducada"></span></td>
                          <td style="text-align: right; padding-right: 10px">{{ lin.cantidad | number: '0.0-0':'es' }}</td>
                          <td class="monospace"
                              title="{{funcLib.CodUbiDecript(lin.ubicacion)}}"
                              [innerHTML]="funcLib.formatUbicacion(lin.ubicacion)"></td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-row-detail>

          <!-- Column Definitions -->
          <ngx-datatable-column [width]="40"
                                [resizeable]="false"
                                [sortable]="false"
                                [draggable]="false"
                                [canAutoResize]="false">
            <ng-template let-row="row"
                         let-expanded="expanded"
                         ngx-datatable-cell-template>
              <a href="javascript:void(0)"
                 [class.datatable-icon-right]="!expanded"
                 [class.datatable-icon-down]="expanded"
                 title="Expand/Collapse Row"
                 (click)="toggleExpandRow(row)"></a>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Palés"
                                prop="pales"
                                [width]="60"
                                [cellClass]="'text-right monospace'"
                                [summaryFunc]="sumaCeldas">
            <ng-template let-value="value"
                         ngx-datatable-cell-template>
              <strong [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></strong>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Almacén"
                                prop="almNombre"
                                [width]="140">
            <ng-template let-value="value"
                         ngx-datatable-cell-template>
              <strong [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></strong>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Fecha Entrada"
                                prop="created_at"
                                [width]="130">
            <ng-template let-value="value"
                         ngx-datatable-cell-template>
              {{ value | date: 'dd/MM/yyyy' }}
            </ng-template>
          </ngx-datatable-column>




          <ngx-datatable-column name="Cliente"
                                prop="cliNombre"
                                [width]="200">
            <ng-template let-value="value"
                         ngx-datatable-cell-template>
              <strong [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></strong>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Albarán"
                                prop="albaran"
                                [width]="150">
            <ng-template let-value="value"
                         ngx-datatable-cell-template>
              <strong [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></strong>
            </ng-template>
          </ngx-datatable-column>




          <!-- Origen, devolucion, NO validado,... -->
          <ngx-datatable-column [width]="130"
                                [sortable]="false">
            <ng-template ngx-datatable-header-template>
              <div class="header ">
                <span class="icon-wrapper mt-1">
                  <i class="fa-solid fa-laptop mr-2"
                     title="Creado por el cliente desde su Intranet "></i>
                  <i class="fa-solid fa-check-circle mr-2"
                     title="Entrada NO validada "></i>
                  <i class="fa-solid fa-rotate-left mr-2"
                     title="Entrada por devolución "></i>
                  <i class="fa-solid fa-triangle-exclamation mr-2"
                     title="Entrada con artículos DEFECTUOSOS "></i>
                  <i class="fa-solid fa-mobile-screen mr-2"
                     title="Entrada editable desde una PDA "></i>
                  <i class="fa-solid fa-truck-ramp-box mr-2"
                     title="Entrada DIRECTA Pda "></i>
                </span>
              </div>
            </ng-template>
            <ng-template let-row="row"
                         ngx-datatable-cell-template>
              <span class="icon-wrapper"
                    title="Creado por el cliente desde su Intranet">
                <i *ngIf="row.origen === Constantes.ENTRADA_ORIGEN_CLIENTE"
                   class="fa-solid fa-laptop text-secondary"></i>
              </span>
              <span class="icon-wrapper"
                    title="Entrada NO validada">
                <i *ngIf="row.swValidado !== '2'"
                   class="fa-solid fa-check-circle text-secondary"></i>
              </span>
              <span class="icon-wrapper"
                    title="Entrada por devolución">
                <i *ngIf="row.devolucion === '1'"
                   class="fa-solid fa-rotate-left text-secondary"></i>
              </span>
              <span class="icon-wrapper"
                    title="Entrada con artículos DEFECTUOSOS">
                <i *ngIf="row.swDefectuoso === 2"
                   class="fa-solid fa-triangle-exclamation text-secondary"></i>
              </span>
              <span class="icon-wrapper"
                    title="Entrada editable desde una PDA">
                <i *ngIf="row.swEditPda === '1'"
                   class="fa-solid fa-mobile-screen text-secondary"></i>
              </span>
              <span class="icon-wrapper"
                    title="Entrada DIRECTA Pda">
                <i *ngIf="row.swEntradaDirecta === '1'"
                   class="fa-solid fa-truck-ramp-box text-secondary"></i>
              </span>

            </ng-template>
          </ngx-datatable-column>



          <ngx-datatable-column name="Líneas"
                                [prop]="'detall'"
                                [width]="90"
                                [cellClass]="'text-right monospace'"
                                [summaryFunc]="sumaCeldasLength">
            <ng-template let-value="value"
                         let-row="row"
                         ngx-datatable-cell-template>
              <strong>{{row.detall?.length}}</strong>
            </ng-template>
          </ngx-datatable-column>





          <!-- Datos de Facturación -->

          <ngx-datatable-column name="Palés fact."
                                prop="fac_pales"
                                [width]="90"
                                [cellClass]="'text-right monospace text-primary'"
                                [headerClass]="'text-primary'"
                                [summaryFunc]="sumaCeldas">
            <ng-template let-value="value"
                         ngx-datatable-cell-template>
              <strong [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></strong>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Horas Fact."
                                prop="fac_horas"
                                [width]="100"
                                [cellClass]="'text-right monospace text-primary'"
                                [headerClass]="'text-primary'"
                                [summaryFunc]="sumaCeldas">
            <ng-template let-value="value"
                         ngx-datatable-cell-template>
              <strong [innerHTML]="funcLib.resaltarTexto((value | number: '1.2-2':'es'), textoDestacado)"></strong>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Etiq. Fact."
                                prop="fac_etiquetas"
                                [width]="90"
                                [cellClass]="'text-right monospace text-primary'"
                                [headerClass]="'text-primary'"
                                [summaryFunc]="sumaCeldas">
            <ng-template let-value="value"
                         ngx-datatable-cell-template>
              <strong [innerHTML]="funcLib.resaltarTexto((value | number: '0.0-0':'es'), textoDestacado)"></strong>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Cont. 20'"
                                prop="fac_contenedor20"
                                [width]="80"
                                [cellClass]="'text-right monospace text-primary'"
                                [headerClass]="'text-primary'"
                                [summaryFunc]="sumaCeldas">
            <ng-template let-value="value"
                         ngx-datatable-cell-template>
              <strong [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></strong>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Cont. 40'"
                                prop="fac_contenedor40"
                                [width]="80"
                                [cellClass]="'text-right monospace text-primary'"
                                [headerClass]="'text-primary'"
                                [summaryFunc]="sumaCeldas">
            <ng-template let-value="value"
                         ngx-datatable-cell-template>
              <strong [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></strong>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column [width]="40"
                                [sortable]="false">
            <ng-template let-row="row"
                         let-value="value"
                         ngx-datatable-cell-template>
              <div ngbDropdown
                   class="d-inline-block"
                   container="body">
                <button class="btn btn-sm btn-outline-secondary dropdown-toggle"
                        data-toggle="dropdown"
                        type="button"
                        style="border-width: 1px;">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-left">
                  <a (click)="creaPdf(row)"
                     class="link mr-2 dropdown-item"
                     title="Crear un PDF con esta entrada">
                    <i class="fa-solid fa-file-pdf"></i> Generar Pdf
                  </a>
                  <a (click)="modalFacturacion(row)"
                     class="link mr-2 dropdown-item"
                     title="Editar datos de FACTURACIÓN">
                    <i class="fa-solid fa-edit"></i> Editar datos facturación
                  </a>
                  <span *ngIf="swEnStock==='1'">
                    <a (click)="confirmaFinalizar(row)"
                       class="link mr-2 dropdown-item"
                       title="Confirmar entrada física en stock">
                      <i class="fa-solid fa-check-circle"></i> Confirmar entrada física
                    </a>
                  </span>
                  <a (click)="avisarCliente(row)"
                     class="link mr-2 dropdown-item"
                     title="NOTIFICAR al cliente vía Intranet">
                    <i class="fa-solid fa-envelope"></i> Notificar al cliente
                  </a>

                  <hr style="margin: 0px;">

                  <a (click)="deleteRow(row)"
                     class="link mr-2 pointer dropdown-item text-danger"
                     placement="top"
                     data-toggle="tooltip"
                     title="Borrar"
                     [ngClass]="{'disabled': row.detall?.length}">
                    <i class="fa-regular fa-trash-can fa"></i> Borrar entrada
                  </a>

                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>



        <!-- barra + botón carga más -->
        <div class="d-flex align-items-center mb-2"
             *ngIf="lista.length < recTotal ">
          <div class="d-flex align-items-center"
               *ngIf="mostrarCargaMas">

            <!-- Texto y barra en vertical -->
            <div class="d-flex flex-column me-3">
              <p class="mb-1">
                <strong>Últimos {{ lista.length | number:'1.0-0' }} de {{ recTotal | number:'1.0-0' }}</strong>
              </p>
              <div class="progress"
                   style="height: 12px; width: 220px;">
                <div class="progress-bar bg-success"
                     role="progressbar"
                     [style.width.%]="(lista.length / recTotal) * 100"
                     [attr.aria-valuenow]="(lista.length / recTotal) * 100"
                     aria-valuemin="0"
                     aria-valuemax="100">
                </div>
              </div>
            </div>

            <!-- Botones a la derecha -->
            <div class="mt-2 ml-2">
              <button [disabled]="loading"
                      (click)="cargaMas()"
                      type="button"
                      class="btn btn-rounded btn-outline-success waves-effect waves-light mr-2">
                <i *ngIf="loading"
                   class="fa fa-spinner fa-spin me-1"></i>
                Cargar más
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div> <!-- row -->


<!-- dashboard de estadísticas (Panel) -->
<span *ngIf="entradasTotales">
  <app-panel-entradas></app-panel-entradas>
</span>


<!-- modal para facturación de entradas -->
<app-modal-fact-entrada></app-modal-fact-entrada>



<!-- Modal para mostrar la imagen -->
<div class="modal-overlay"
     *ngIf="imagenSeleccionada"
     (click)="cerrarPopupImagen()">
  <div class="modal-content">
    <img [src]="imagenSeleccionada"
         class="modal-image"
         alt="Imagen seleccionada">
  </div>
</div>